export class ShippingAccountModel {
  customerShippingAccountId: number;
  customerId: number;
  accountNumber?: string;
  type?: string;
}